enum ConfigType {
  linkToRegisterForLiveStudySessions = "linkToRegisterForLiveStudySessions",
  linkToJoinForDesignatedSupervisorSupportGroup = "linkToJoinForDesignatedSupervisorSupportGroup",
  linkToRegisterForDesignatedSupervisorLiveStudySessions = "linkToRegisterForDesignatedSupervisorLiveStudySessions",
}

export default ConfigType;
